import React, { useState } from "react";
import images from "../../Constant/images";
import { Container, EachChart, ChartContent } from "./styles";
import SmartImage from "../../Components/SmartImage";
import CustomText from "../../Components/Text";
import Colors from "../../Constant/Colors";
import { FONTS, STYLES } from "../../Constant/Theme";

const IntroductionPage = ({}) => {
  return (
    <Container>
      <p>Introduction Pages</p>
    </Container>
  );
};

export default IntroductionPage;
